import { Result, Card, Typography, Space } from "antd";
import { ConfigStepId, ConfigStepType } from "../utils/configuration";
import ApplicantInfo from "./organisms/Admin/ApplicantInfo";
import Complete from "./organisms/Admin/Complete";
import Welcome from "./organisms/Admin/Welcome";
import Transcript from "./organisms/Admin/Transcript";
import Business from "./organisms/Admin/Business";
import {
    FileTextOutlined,
    CheckCircleOutlined,
    HomeOutlined,
    UserOutlined,
    QuestionCircleOutlined,
    BankOutlined
} from "@ant-design/icons";
import { CSSProperties } from "react";

const { Title, Text } = Typography;

const styles: Record<string, CSSProperties> = {
    container: {
        padding: '24px',
    },
    header: {
        marginBottom: '16px',
        paddingBottom: '16px',
        borderBottom: '1px solid #f0f0f0',
    },
    iconWrapper: {
        fontSize: '24px',
        marginRight: '12px',
    },
};

interface AdminStepParams {
    step: ConfigStepType;
    stepIndex: number;
}

const getStepIcon = (stepId: string) => {
    switch (stepId) {
        case ConfigStepId.welcome:
            return <HomeOutlined style={{ ...styles.iconWrapper, color: '#1890ff' }} />;
        case ConfigStepId.complete:
            return <CheckCircleOutlined style={{ ...styles.iconWrapper, color: '#52c41a' }} />;
        case ConfigStepId.info:
            return <UserOutlined style={{ ...styles.iconWrapper, color: '#722ed1' }} />;
        case ConfigStepId.transcript:
            return <FileTextOutlined style={{ ...styles.iconWrapper, color: '#fa8c16' }} />;
        case ConfigStepId.business:
            return <BankOutlined style={{ ...styles.iconWrapper, color: '#13c2c2' }} />;
        default:
            return <QuestionCircleOutlined style={{ ...styles.iconWrapper, color: '#8c8c8c' }} />;
    }
};

const AdminStep = ({
    step,
    stepIndex,
}: AdminStepParams) => {
    const renderStepContent = () => {
        switch (step.id) {
            case ConfigStepId.welcome:
                return <Welcome {...step.params} />;
            case ConfigStepId.complete:
                return <Complete />;
            case ConfigStepId.info:
                return <ApplicantInfo />;
            case ConfigStepId.transcript:
                return <Transcript step={step} stepIndex={stepIndex} />;
            case ConfigStepId.business:
                return <Business step={step} stepIndex={stepIndex} />;
            default:
                return (
                    <Result
                        status="404"
                        title="Step Not Found"
                        subTitle={`The step configuration for "${(step as ConfigStepType).name}" is not implemented yet.`}
                    />
                );
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <Space align="center">
                    {getStepIcon(step.id)}
                    <div>
                        <Title level={4} style={{ margin: 0 }}>
                            Step {stepIndex + 1}: {step.name}
                        </Title>
                        <Text type="secondary">{step.description}</Text>
                    </div>
                </Space>
            </div>
            <Card>
                {renderStepContent()}
            </Card>
        </div>
    );
};

export default AdminStep;
